import serviceRequest from "utils/request";

const baseUrl = "/api/user";

export const getUserDetailById = (param) => {
	return serviceRequest({
		url: `${baseUrl}/get-user-detail-by-id?userId=${param.userId}`,
		method: "get",
	});
};

export const forgetResetPwd = (param) => {
	return serviceRequest({
		url: `${baseUrl}/forget-reset-password`,
		method: "post",
		data: param,
	});
};

export const getUserList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/user-list`,
		method: "post",
		data: param,
	});
};

export const getInactiveUsers = () => {
	return serviceRequest({
		url: `${baseUrl}/inactive-users`,
		method: "get",
	});
};

export const notifyInactiveUsers = (userIds) => {
	return serviceRequest({
		url: `${baseUrl}/inactive-users/notify`,
		method: "post",
		data: { userIds },
	});
};

export const getUserListByOrg = (params) => {
	return serviceRequest({
		url: `${baseUrl}/user-list-by-org`,
		method: "get",
		params,
	});
};

export const deleteUser = (param) => {
	return serviceRequest({
		url: `${baseUrl}/delete-user?id=${param.id}`,
		method: "delete",
	});
};

export const createUser = (param) => {
	return serviceRequest({
		url: `${baseUrl}/create-user`,
		method: "post",
		data: param,
	});
};

export const editUser = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit-user`,
		method: "post",
		data: param,
	});
};

export const getUserInfo = () => {
	const accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		return serviceRequest({
			url: `${baseUrl}/user-info`,
			method: "get",
		});
	} else {
		return new Promise((resolve, reject) => {
			reject();
		});
	}
};

export const exportUserList = (data) => {
	return serviceRequest({
		url: `${baseUrl}/export-user-list`,
		method: "post",
		responseType: "blob",
		data,
	});
};

export const getExpertProjectAddableUserList = (param) => {
	return serviceRequest({
		url: `${baseUrl}/expert/addable-user-list`,
		method: "post",
		data: param,
	});
};

export const getUserProfileDetail = () => {
	return serviceRequest({
		url: `${baseUrl}/user-profile/detail`,
		method: "get",
	});
};

export const editCurrentUser = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit-current-user`,
		method: "post",
		data: param,
	});
};
